import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';
import { SupplierMapping, Unit } from '@synergy/models';

export class SupplierUnitMappingApi {
    constructor(protected baseUrl: string) {}

    public getUnitMapping(
        supplierId: number,
        params: URLSearchParams = new URLSearchParams()
    ): Promise<ApiResult<PaginatedResponse<SupplierMapping<Unit>>>> {
        return safeRequest(
            () => {
                return request.get<PaginatedResponse<SupplierMapping<Unit>>>(
                    `${this.baseUrl}/suppliers/${supplierId}/units/mapping`,
                    { params }
                );
            },
            response => {
                return response.data;
            }
        );
    }

    public updateUnitMapping(
        supplierId: number,
        unitMapping: SupplierMapping<Unit>
    ): Promise<ApiResult<SupplierMapping<Unit>>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/suppliers/${supplierId}/units/${unitMapping.id}/mapping`, {
                    values: unitMapping.supplierMapping,
                }),
            response => response.data
        );
    }
}
